import React from 'react';
import PropTypes from 'prop-types';
import Link from '../../Atoms/Link';
import { useSourceIdCookie } from '../../../utilities/useContentReplacers/contentReplacers/sourceid/useSourceIdCookie';
import { replaceLearningCenterSourceId } from '../../../utilities/useContentReplacers/contentReplacers/sourceid/learningCenterSourceId';
import { testAttributes } from './Constants';

const LearningCenterSourceIdLink = ({
    children,
    href = '',
    articleId = null,
    ...props
}) => 
{
    const { sourceid, location } = useSourceIdCookie();
    if (!location) return null;
    return (
        <Link
            {...props}
            href={replaceLearningCenterSourceId({
                href,
                location,
                sourceid,
                articleId,
            })}
            data-testid={
                props['data-testid'] ||
                testAttributes.LEARNING_CENTER_SOURCE_ID_LINK
            }
        >
            {children}
        </Link>
    );
};

LearningCenterSourceIdLink.propTypes = {
    /** Content or React Node */
    children: PropTypes.node.isRequired,
    /** URL, if containing sourceid hash, will be processed for replacement */
    href: PropTypes.string,
    /** Article identifier set dynamically from GraphQL query */
    articleId: PropTypes.oneOfType([
        PropTypes.string, PropTypes.number
    ]),
    /** (Optional) data-testid passed to component. Defaults to generic Learning Center test ID */
    'data-testid': PropTypes.string,
};

export default LearningCenterSourceIdLink;
